import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT,
  FOOTBALL_ONBOARDING_TUTORIAL_WIN,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

import { MarketGuidanceLayout } from 'components/onboarding/MarketGuidanceLayout';
import { PlayLineupAnimation } from 'components/onboarding/PlayLineupAnimation';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
`;
const StyledOnboardingButton = styled(OnboardingButton)`
  position: sticky;
  bottom: var(--double-unit);
  align-self: center;
`;

const TutorialPlayPage = () => {
  return (
    <MarketGuidanceLayout
      progress={25}
      center
      backUrl={FOOTBALL_ONBOARDING_TUTORIAL_RECRUIT}
    >
      <Root>
        <Vertical gap={1.5} center>
          <FormattedMessage
            id="TutorialPlayPage.title"
            defaultMessage="<em>Play</em><label>with lineups of 5 players</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <PlayLineupAnimation />
        <StyledOnboardingButton
          size="large"
          color="secondary"
          to={FOOTBALL_ONBOARDING_TUTORIAL_WIN}
          prefetch="render"
        >
          <FormattedMessage {...glossary.continue} />
        </StyledOnboardingButton>
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialPlayPage;
